import { t as W, u as U, B as L, v as k, f as I, w as $ } from "./main-bb89b2f2.js";
import { t as R } from "./toNumber-f405d8e0-e5c83f11.js";
var j = function() {
  return $.Date.now();
};
const C = j;
var H = "Expected a function", P = Math.max, B = Math.min;
function D(e, r, t) {
  var i, f, m, g, a, d, p = 0, l = !1, E = !1, v = !0;
  if (typeof e != "function")
    throw new TypeError(H);
  r = R(r) || 0, U(t) && (l = !!t.leading, E = "maxWait" in t, m = E ? P(R(t.maxWait) || 0, r) : m, v = "trailing" in t ? !!t.trailing : v);
  function w(c) {
    var h = i, T = f;
    return i = f = void 0, p = c, g = e.apply(T, h), g;
  }
  function n(c) {
    return p = c, a = setTimeout(u, r), l ? w(c) : g;
  }
  function s(c) {
    var h = c - d, T = c - p, S = r - h;
    return E ? B(S, m - T) : S;
  }
  function o(c) {
    var h = c - d, T = c - p;
    return d === void 0 || h >= r || h < 0 || E && T >= m;
  }
  function u() {
    var c = C();
    if (o(c))
      return x(c);
    a = setTimeout(u, s(c));
  }
  function x(c) {
    return a = void 0, v && i ? w(c) : (i = f = void 0, g);
  }
  function O() {
    a !== void 0 && clearTimeout(a), p = 0, i = d = f = a = void 0;
  }
  function A() {
    return a === void 0 ? g : x(C());
  }
  function y() {
    var c = C(), h = o(c);
    if (i = arguments, f = this, d = c, h) {
      if (a === void 0)
        return n(d);
      if (E)
        return clearTimeout(a), a = setTimeout(u, r), w(d);
    }
    return a === void 0 && (a = setTimeout(u, r)), g;
  }
  return y.cancel = O, y.flush = A, y;
}
const F = (e, r, t) => {
  const i = e.get(r);
  i ? i.includes(t) || i.push(t) : e.set(r, [t]);
}, K = (e, r) => {
  let t;
  return (...i) => {
    t && clearTimeout(t), t = setTimeout(() => {
      t = 0, e(...i);
    }, r);
  };
}, V = (e) => !("isConnected" in e) || e.isConnected, _ = K((e) => {
  for (let r of e.keys())
    e.set(r, e.get(r).filter(V));
}, 2e3), z = () => {
  if (typeof k != "function")
    return {};
  const e = /* @__PURE__ */ new Map();
  return {
    dispose: () => e.clear(),
    get: (r) => {
      const t = k();
      t && F(e, r, t);
    },
    set: (r) => {
      const t = e.get(r);
      t && e.set(r, t.filter(I)), _(e);
    },
    reset: () => {
      e.forEach((r) => r.forEach(I)), _(e);
    }
  };
}, M = (e) => typeof e == "function" ? e() : e, X = (e, r = (t, i) => t !== i) => {
  const t = M(e);
  let i = new Map(Object.entries(t ?? {}));
  const f = {
    dispose: [],
    get: [],
    set: [],
    reset: []
  }, m = () => {
    var n;
    i = new Map(Object.entries((n = M(e)) !== null && n !== void 0 ? n : {})), f.reset.forEach((s) => s());
  }, g = () => {
    f.dispose.forEach((n) => n()), m();
  }, a = (n) => (f.get.forEach((s) => s(n)), i.get(n)), d = (n, s) => {
    const o = i.get(n);
    r(s, o, n) && (i.set(n, s), f.set.forEach((u) => u(n, s, o)));
  }, p = typeof Proxy > "u" ? {} : new Proxy(t, {
    get(n, s) {
      return a(s);
    },
    ownKeys(n) {
      return Array.from(i.keys());
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    },
    has(n, s) {
      return i.has(s);
    },
    set(n, s, o) {
      return d(s, o), !0;
    }
  }), l = (n, s) => (f[n].push(s), () => {
    b(f[n], s);
  });
  return {
    state: p,
    get: a,
    set: d,
    on: l,
    onChange: (n, s) => {
      const o = l("set", (x, O) => {
        x === n && s(O);
      }), u = l("reset", () => s(M(e)[n]));
      return () => {
        o(), u();
      };
    },
    use: (...n) => {
      const s = n.reduce((o, u) => (u.set && o.push(l("set", u.set)), u.get && o.push(l("get", u.get)), u.reset && o.push(l("reset", u.reset)), u.dispose && o.push(l("dispose", u.dispose)), o), []);
      return () => s.forEach((o) => o());
    },
    dispose: g,
    reset: m,
    forceUpdate: (n) => {
      const s = i.get(n);
      f.set.forEach((o) => o(n, s, s));
    }
  };
}, b = (e, r) => {
  const t = e.indexOf(r);
  t >= 0 && (e[t] = e[e.length - 1], e.length--);
}, q = (e, r) => {
  const t = X(e, r);
  return t.use(z()), t;
}, { state: G } = q(W({
  width: window.innerWidth,
  height: window.innerHeight,
  thresholds: L
})), J = D((e) => {
  Object.assign(G, W({
    width: e.target.innerWidth,
    height: e.target.innerHeight,
    thresholds: L
  }));
}, 16);
window.addEventListener("resize", J, {
  passive: !0
});
export {
  G as $,
  D as d
};
